// extracted by mini-css-extract-plugin
export default {"container":"styles_container__0vadm","label":"styles_label__Fob+l","form":"styles_form__-mTT2","select":"styles_select__K4hF+"};